module.exports = __webpack_public_path__ + "img/no-tickets.6cf357cf.svg";